import React from 'react';

export default function FilterBar({
  language,   setLanguage,
  country,    setCountry,
  category,   setCategory,

  languages  = [],
  countries  = [],
  categories = []
}) {
  return (
    <div className="filter-bar d-flex gap-3 mb-3">
      <select
        className="filter-bar_select filter-bar_language-select form-select"
        value={language}
        onChange={e => setLanguage(e.target.value)}
      >
        <option value="">All Languages</option>
        {languages.map(lang => (
          <option key={lang} value={lang}>
            {lang}
          </option>
        ))}
      </select>

      <select
        className="filter-bar_select filter-bar_country-select form-select"
        value={country}
        onChange={e => setCountry(e.target.value)}
      >
        <option value="">All Countries</option>
        {countries.map(cnt => (
          <option key={cnt} value={cnt}>
            {cnt}
          </option>
        ))}
      </select>

      <select
        className="filter-bar_select filter-bar_category-select form-select"
        value={category}
        onChange={e => setCategory(e.target.value)}
      >
        <option value="">All Categories</option>
        {categories.map(cat => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>
    </div>
  );
}
